module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowComment),
      expression: "!isShowComment"
    }],
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', [_vm._s(_vm.homeworkInfo.studentName) + "的作业"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('mt-loadmore', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowComment),
      expression: "!isShowComment"
    }],
    ref: "loadmore",
    attrs: {
      "top-method": _vm.loadTop
    }
  }, [_vm._h('div', {
    staticClass: "main-page",
    on: {
      "click": function($event) {
        _vm.isShowTop = false
      }
    }
  }, [_vm._h('div', {
    staticClass: "dynamic homework-detail"
  }, [_vm._h('div', [_vm._h('div', {
    staticClass: "padding-15 clearfix bg-white"
  }, [_vm._h('div', {
    staticClass: "pull-left left-part"
  }, [_vm._h('div', {
    staticClass: "img-wrap small"
  }, [_vm._h('img', {
    staticClass: "mid-align",
    attrs: {
      "src": _vm.homeworkInfo.imageAddress ? _vm.baseAcessPath + _vm.homeworkInfo.imageAddress : _vm.img_default
    }
  })])]), " ", _vm._h('div', {
    staticClass: "right-part"
  }, [_vm._h('span', {
    staticClass: "font-16",
    staticStyle: {
      "color": "#449"
    }
  }, [_vm._s(_vm.homeworkInfo.userName)]), " ", _vm._h('p', [_vm._s(_vm.homeworkInfo.content)]), " ", _vm._h('ul', {
    staticClass: "block clearfix imgs"
  }, [_vm._l((_vm.homeworkInfo.imageList), function(img, index) {
    return _vm._h('li', {
      staticClass: "col-xs-4"
    }, [_vm._h('div', {
      staticClass: "t-r-5"
    }, [_vm._h('div', {
      staticClass: "out-wrap"
    }, [_vm._h('span', {
      on: {
        "click": function($event) {
          _vm.showImgList(_vm.homeworkInfo.imageList, index)
        }
      }
    }, [_vm._h('img', {
      staticClass: "mid-align",
      attrs: {
        "src": img.baseAcessPath + img.thumbAddress
      }
    })])])])])
  })]), " ", _vm._h('div', {
    staticClass: "clearfix"
  }, [_vm._h('cite', {
    staticClass: "gray pull-left font-12"
  }, [_vm._s(_vm._f("dateDiff")(_vm.homeworkInfo.publishDate))]), " ", (_vm.homeworkInfo.userId == _vm.teacherId && _vm.homeworkInfo.clientType == 'teacher') ? _vm._h('span', {
    staticClass: "pull-left margin-x-15 font-12",
    on: {
      "click": function($event) {
        _vm.isHideDelhomework = false
      }
    }
  }, ["删除"]) : _vm._e(), " ", _vm._h('span', {
    staticClass: "pull-right icon-p-c",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.isShowTop = !_vm.isShowTop
      }
    }
  }, ["更多"]), " ", _vm._h('div', {
    staticClass: "tips-comwrap"
  }, [_vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowTop),
      expression: "isShowTop"
    }],
    staticClass: "tip-comment"
  }, [(_vm.homeworkInfo.isDz) ? _vm._h('div', {
    staticClass: "col-xs-6"
  }, [_vm._h('span', {
    staticClass: "icon-praise",
    on: {
      "click": function($event) {
        _vm.cancelDz()
      }
    }
  }, ["取消"])]) : _vm._h('div', {
    staticClass: "col-xs-6"
  }, [_vm._h('span', {
    staticClass: "icon-praise",
    on: {
      "click": function($event) {
        _vm.dz()
      }
    }
  }, ["点赞"])]), " ", " ", _vm._h('div', {
    staticClass: "col-xs-6"
  }, [_vm._h('span', {
    staticClass: "icon-comment",
    on: {
      "click": function($event) {
        _vm.isShowComment = true
      }
    }
  }, ["评论"])])])])]), " ", ((_vm.homeworkInfo.dzList && _vm.homeworkInfo.dzList.length > 0) || (_vm.homeworkInfo.plList && _vm.homeworkInfo.plList.length > 0)) ? _vm._h('div', {
    staticClass: "comment"
  }, [(_vm.homeworkInfo.dzList && _vm.homeworkInfo.dzList.length > 0) ? _vm._h('div', {
    staticClass: "icon-praise praiser"
  }, [_vm._l((_vm.homeworkInfo.dzList), function(dz, index) {
    return _vm._h('span', ["\n                  " + _vm._s(dz.commentUserName) + " " + _vm._s(index == _vm.homeworkInfo.dzList.length - 1 ? '' : '、') + "\n                "])
  })]) : _vm._e(), " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.homeworkInfo.dzList && _vm.homeworkInfo.dzList.length > 0) || (_vm.homeworkInfo.plList && _vm.homeworkInfo.plList.length > 0)),
      expression: "(homeworkInfo.dzList && homeworkInfo.dzList.length > 0)|| (homeworkInfo.plList && homeworkInfo.plList.length > 0)"
    }],
    staticClass: "liner"
  }), " ", (_vm.homeworkInfo.plList.length > 0) ? _vm._h('ul', {
    staticClass: "con-comment"
  }, [_vm._l((_vm.homeworkInfo.plList), function(pl, index) {
    return _vm._h('li', {
      staticClass: "clearfix",
      on: {
        "click": function($event) {
          _vm.showDelComment(pl, index)
        }
      }
    }, [_vm._h('span', [_vm._s(pl.commentUserName) + ":"]), "\n                    " + _vm._s(pl.content) + "\n                  "])
  })]) : _vm._e()]) : _vm._e()])]), " ", _vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', [_vm._h('span', {
    staticClass: "block",
    staticStyle: {
      "margin": "10px"
    }
  }, ["已阅："]), " ", _vm._h('ul', {
    staticClass: "list-group-item"
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('div', {
    staticClass: "clearfix padding-15"
  }, [_vm._l((_vm.homeworkInfo.readList), function(item) {
    return _vm._h('div', {
      staticClass: "pull-left reader"
    }, [_vm._h('a', {
      staticClass: "block text-center",
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._h('span', {
      staticClass: "img-wrap small block"
    }, [_vm._h('img', {
      attrs: {
        "src": item.imageAddress ? _vm.baseAcessPath + item.imageAddress : _vm.img_default,
        "width": "100%"
      }
    })]), " ", _vm._h('cite', {
      staticClass: "gray font-12"
    }, [_vm._s(item.userName)])])])
  })])])])])])])])]), " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowComment),
      expression: "isShowComment"
    }],
    staticClass: "main-page"
  }, [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isShowComment = false
      }
    }
  }, ["返回"]), " ", _vm._h('h1'), " ", _vm._h('span', {
    staticClass: "pull-right icon-right orange",
    on: {
      "click": function($event) {
        _vm.insertHomeWorkComment()
      }
    }
  }, ["发送"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._h('div', {
    staticClass: "padding-15 bg-white"
  }, [_vm._h('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "font-14",
    attrs: {
      "width": "100%",
      "rows": "5",
      "placeholder": "这一刻的想法..."
    },
    domProps: {
      "value": _vm._s(_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })])]), " ", " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideDelhomework),
      expression: "!isHideDelhomework"
    }],
    staticClass: "maskdiv",
    on: {
      "click": function($event) {
        _vm.isHideDelhomework = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "popover",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('div', {
    staticClass: "pop-wrap text-center"
  }, [_vm._h('p', {
    staticClass: "margin-15"
  }, ["确认要删除这条动态吗？"]), " ", _vm._h('div', {
    staticClass: "liner margin-15"
  }), " ", _vm._h('div', {
    staticClass: "clearfix"
  }, [_vm._h('div', {
    staticClass: "col-xs-6 blue"
  }, [_vm._h('a', {
    staticClass: "blue  block",
    staticStyle: {
      "border-right": "1px solid #ddd"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteHomeWork()
      }
    }
  }, ["删除"])]), " ", _vm._h('div', {
    staticClass: "col-xs-6 blue"
  }, [_vm._h('a', {
    staticClass: "blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideDelhomework = true
      }
    }
  }, ["不删除"])])])])])]), " ", " ", _vm._h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isHideDelComment),
      expression: "!isHideDelComment"
    }],
    staticClass: "maskdiv",
    on: {
      "click": function($event) {
        _vm.isHideDelComment = true
      }
    }
  }, [_vm._h('div', {
    staticClass: "bottom-block text-center",
    staticStyle: {
      "background": "none"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm._h('ul', {
    staticClass: "list-group-item  tinny"
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('a', {
    staticClass: "group-txt",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteComment()
      }
    }
  }, [_vm._h('span', {
    staticClass: "orange block font-16"
  }, ["删除"])])])]), " ", _vm._h('ul', {
    staticClass: "list-group-item tinny",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._h('li', {
    staticClass: "list-group"
  }, [_vm._h('div', {
    staticClass: "liner"
  }), " ", _vm._h('a', {
    staticClass: "group-txt",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.isHideDelComment = true
      }
    }
  }, [_vm._h('span', {
    staticClass: "block font-16"
  }, ["取消"])])])])])]), " ", (_vm.isShowImgs) ? _vm._h('div', {
    staticClass: "maskdiv",
    staticStyle: {
      "background": "rgba(0,0,0,1)"
    },
    on: {
      "click": function($event) {
        _vm.isShowImgs = false
      }
    }
  }, [_vm._h('div', {
    staticClass: "imgs-box"
  }, [_vm._h('div', {
    staticClass: "swiper-container"
  }, [_vm._h('div', {
    staticClass: "swiper-wrapper"
  }, [_vm._l((_vm.imageList), function(item) {
    return _vm._h('div', {
      staticClass: "swiper-slide",
      staticStyle: {
        "height": "100vh"
      }
    }, [_vm._h('img', {
      staticClass: "swiper-lazy bigger-pic hide",
      attrs: {
        "data-src": item.baseAcessPath + item.imageAddress,
        "thumbImg": item.baseAcessPath + item.thumbAddress
      }
    })])
  })]), " ", " ", _vm._h('div', {
    staticClass: "swiper-pagination"
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-2294711c!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/homework/homeworkDetail.vue
// module id = 186
// module chunks = 1